import React from 'react'

export default function ResourceGroup({ title, icon, count, children }) {
  return (
    <section className="resource-group">
      <div className="resource-group-title">
        {icon}
        <h3>{title}</h3>
        {typeof count === 'number' && <span className="group-count">{count} 项</span>}
      </div>
      <hr className="resource-group-rule" />
      <div className="resource-grid">{children}</div>
    </section>
  )
}
